import { render, staticRenderFns } from "./DefectStaticCardNew.vue?vue&type=template&id=9e831bb6&scoped=true&"
import script from "./DefectStaticCardNew.vue?vue&type=script&lang=js&"
export * from "./DefectStaticCardNew.vue?vue&type=script&lang=js&"
import style0 from "./DefectStaticCardNew.vue?vue&type=style&index=0&id=9e831bb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e831bb6",
  null
  
)

export default component.exports